import { ROUTES } from 'views/Configure/stubs';

const BASE_URL = ROUTES.SHIPPING_METHODS;

export default {
  CONFIGURE: ROUTES.HOME,
  SHIPPING: ROUTES.SHIPPING,
  HOME: BASE_URL,
  SHIPPING_METHOD_DETAILS: `${BASE_URL}/:id`
};
